const NS = 'DialogController';

export default function DialogController(
  $mdDialog, dialogMessage, headerMsg, confirmButton, cancelButton, diffInfoList = null
) {
  const vm = this;

  vm.enter = enter;
  vm.cancel = cancel;

  vm.dialogMessage = dialogMessage;
  vm.headerMsg = headerMsg;
  vm.confirmButton = confirmButton;
  vm.cancelButton = cancelButton;
  vm.diffInfoList = diffInfoList;
  function cancel() {
    $mdDialog.cancel();
  }

  function enter () {
    $mdDialog.hide('success');
  }
}
